import React, { useState } from "react";
import { toast } from "react-toastify";

export default function AddPayslipForm({ onCancel, onSave, editPayslip = null }) {
  const [form, setForm] = useState(editPayslip || {
    payslipNo: `PS-${new Date().getFullYear()}-${Math.floor(Math.random() * 9000 + 1000)}`,
    month: "",
    year: new Date().getFullYear(),
    employeeName: "",
    employeeId: "",
    designation: "",
    department: "",
    doj: "",
    dob: "",
    bankAccount: "",
    ifsc: "",
    pan: "",
    uan: "",
    daysWorked: "",
    earnings: {
      basicPay: "",
      hra: "",
      specialAllowance: "",
      incentive: "",
      totalEarnings: "",
    },
    deductions: {
      pf: "",
      professionalTax: "",
      incomeTax: "",
      other: "",
      totalDeductions: "",
    },
    netSalary: {
      figures: "",
      words: "",
    },
  });

  const handleChange = (field, value) => {
    setForm((prev) => ({ ...prev, [field]: value }));
  };

  const handleNestedChange = (section, field, value) => {
    setForm((prev) => ({
      ...prev,
      [section]: { ...prev[section], [field]: value },
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!form.employeeName || !form.employeeId) {
      toast.error("Employee Name & ID are required!");
      return;
    }
    if (onSave) onSave(form);
    toast.success(editPayslip ? "Payslip updated successfully!" : "Payslip saved successfully!");
    onCancel();
  };

  return (
    <form
      onSubmit={handleSubmit}
      className="bg-[#0d0d0d] p-6 rounded-lg shadow-lg text-white text-sm overflow-y-auto max-h-[90vh]"
    >


      <h3 className="font-semibold text-yellow-400 mb-2">
        Payslip for {form.month || "___"} {form.year}
      </h3>

      {/* Payslip Info */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div>
          <label className="text-gray-400 text-sm block mb-1">Payslip No.</label>
          <input
            value={form.payslipNo}
            onChange={(e) => handleChange("payslipNo", e.target.value)}
            className="w-full px-3 py-2 rounded bg-[#131313] border border-[#444]"
          />
        </div>
        <div>
          <label className="text-gray-400 text-sm block mb-1">Month</label>
          <input
            placeholder="Month"
            value={form.month}
            onChange={(e) => handleChange("month", e.target.value)}
            className="w-full px-3 py-2 rounded bg-[#131313] border border-[#444]"
          />
        </div>
        <div>
          <label className="text-gray-400 text-sm block mb-1">Year</label>
          <input
            type="number"
            placeholder="Year"
            value={form.year}
            onChange={(e) => handleChange("year", e.target.value)}
            className="w-full px-3 py-2 rounded bg-[#131313] border border-[#444]"
          />
        </div>
      </div>

      <hr className="my-4 border-[#333]" />

      {/* Employee Details */}
      <h3 className="font-semibold text-yellow-400 mb-2">Employee Details</h3>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <input placeholder="Employee Name" value={form.employeeName} onChange={(e) => handleChange("employeeName", e.target.value)} className="px-3 py-2 rounded bg-[#131313] border border-[#444]" />
        <input placeholder="Employee ID" value={form.employeeId} onChange={(e) => handleChange("employeeId", e.target.value)} className="px-3 py-2 rounded bg-[#131313] border border-[#444]" />
        <input placeholder="Designation" value={form.designation} onChange={(e) => handleChange("designation", e.target.value)} className="px-3 py-2 rounded bg-[#131313] border border-[#444]" />
        <input placeholder="Department" value={form.department} onChange={(e) => handleChange("department", e.target.value)} className="px-3 py-2 rounded bg-[#131313] border border-[#444]" />
        <input type="date" placeholder="Date of Joining" value={form.doj} onChange={(e) => handleChange("doj", e.target.value)} className="px-3 py-2 rounded bg-[#131313] border border-[#444]" />
        <input type="date" placeholder="Date of Birth" value={form.dob} onChange={(e) => handleChange("dob", e.target.value)} className="px-3 py-2 rounded bg-[#131313] border border-[#444]" />
      </div>

      <hr className="my-4 border-[#333]" />

      {/* Banking Details */}
      <h3 className="font-semibold text-yellow-400 mb-2">Banking Details</h3>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <input placeholder="Bank A/C No." value={form.bankAccount} onChange={(e) => handleChange("bankAccount", e.target.value)} className="px-3 py-2 rounded bg-[#131313] border border-[#444]" />
        <input placeholder="IFSC" value={form.ifsc} onChange={(e) => handleChange("ifsc", e.target.value)} className="px-3 py-2 rounded bg-[#131313] border border-[#444]" />
        <input placeholder="PAN" value={form.pan} onChange={(e) => handleChange("pan", e.target.value)} className="px-3 py-2 rounded bg-[#131313] border border-[#444]" />
        <input placeholder="UAN" value={form.uan} onChange={(e) => handleChange("uan", e.target.value)} className="px-3 py-2 rounded bg-[#131313] border border-[#444]" />
        <input placeholder="Days Worked" value={form.daysWorked} onChange={(e) => handleChange("daysWorked", e.target.value)} className="px-3 py-2 rounded bg-[#131313] border border-[#444]" />
      </div>

      <hr className="my-4 border-[#333]" />

      {/* Earnings */}
      <h3 className="font-semibold text-yellow-400 mb-2">Earnings</h3>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <input placeholder="Basic Pay" value={form.earnings.basicPay} onChange={(e) => handleNestedChange("earnings", "basicPay", e.target.value)} className="px-3 py-2 rounded bg-[#131313] border border-[#444]" />
        <input placeholder="House Rent Allowance" value={form.earnings.hra} onChange={(e) => handleNestedChange("earnings", "hra", e.target.value)} className="px-3 py-2 rounded bg-[#131313] border border-[#444]" />
        <input placeholder="Special Allowance" value={form.earnings.specialAllowance} onChange={(e) => handleNestedChange("earnings", "specialAllowance", e.target.value)} className="px-3 py-2 rounded bg-[#131313] border border-[#444]" />
        <input placeholder="Performance Incentive" value={form.earnings.incentive} onChange={(e) => handleNestedChange("earnings", "incentive", e.target.value)} className="px-3 py-2 rounded bg-[#131313] border border-[#444]" />
        <input placeholder="Total Earnings" value={form.earnings.totalEarnings} onChange={(e) => handleNestedChange("earnings", "totalEarnings", e.target.value)} className="px-3 py-2 rounded bg-[#131313] border border-[#444]" />
      </div>

      <hr className="my-4 border-[#333]" />

      {/* Deductions */}
      <h3 className="font-semibold text-yellow-400 mb-2">Deductions</h3>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <input placeholder="Provident Fund (PF)" value={form.deductions.pf} onChange={(e) => handleNestedChange("deductions", "pf", e.target.value)} className="px-3 py-2 rounded bg-[#131313] border border-[#444]" />
        <input placeholder="Professional Tax" value={form.deductions.professionalTax} onChange={(e) => handleNestedChange("deductions", "professionalTax", e.target.value)} className="px-3 py-2 rounded bg-[#131313] border border-[#444]" />
        <input placeholder="Income Tax (TDS)" value={form.deductions.incomeTax} onChange={(e) => handleNestedChange("deductions", "incomeTax", e.target.value)} className="px-3 py-2 rounded bg-[#131313] border border-[#444]" />
        <input placeholder="Other Deductions" value={form.deductions.other} onChange={(e) => handleNestedChange("deductions", "other", e.target.value)} className="px-3 py-2 rounded bg-[#131313] border border-[#444]" />
        <input placeholder="Total Deductions" value={form.deductions.totalDeductions} onChange={(e) => handleNestedChange("deductions", "totalDeductions", e.target.value)} className="px-3 py-2 rounded bg-[#131313] border border-[#444]" />
      </div>

      <hr className="my-4 border-[#333]" />

      {/* Net Pay */}
      <h3 className="font-semibold text-yellow-400 mb-2">Net Pay</h3>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <input placeholder="Net Salary (in figures) ₹" value={form.netSalary.figures} onChange={(e) => handleNestedChange("netSalary", "figures", e.target.value)} className="px-3 py-2 rounded bg-[#131313] border border-[#444]" />
        <input placeholder="Net Salary (in words)" value={form.netSalary.words} onChange={(e) => handleNestedChange("netSalary", "words", e.target.value)} className="px-3 py-2 rounded bg-[#131313] border border-[#444]" />
      </div>

      <p className="text-xs text-gray-400 mt-4 italic">
        *This is a computer-generated payslip and does not require a physical signature.
      </p>

      {/* Buttons */}
      <div className="flex justify-between mt-6">
        <button type="button" onClick={onCancel} className="bg-[#2b2b2b] text-white px-4 py-2 rounded text-sm border border-[#444]">
          Cancel
        </button>
        <button type="submit" className="bg-yellow-400 text-black px-4 py-2 rounded text-sm font-semibold">
          {editPayslip ? "Update Payslip ✓" : "Save Payslip ✓"}
        </button>
      </div>
    </form>
  );
}